import { type ButtonHTMLAttributes } from 'react'

import { cn } from '@/utils/cn'

type ButtonVariant = 'primary' | 'secondary' | 'ghost'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  isLoading?: boolean
}

const variantClassNames: Record<ButtonVariant, string> = {
  primary: 'bg-ice text-canvas active:bg-ice/80',
  secondary: 'border border-ice/48 bg-panel text-ink active:bg-panel/70',
  ghost: 'bg-transparent text-secondary active:bg-white/5',
}

export function Button({
  variant = 'primary',
  isLoading = false,
  disabled,
  className,
  type = 'button',
  children,
  ...buttonAttributes
}: ButtonProps) {
  const isDisabled = disabled === true || isLoading

  return (
    <button
      type={type}
      disabled={isDisabled}
      aria-busy={isLoading}
      className={cn(
        'inline-flex h-11 items-center justify-center gap-2 rounded-card px-4 text-sm font-semibold transition-colors disabled:opacity-50',
        variantClassNames[variant],
        className,
      )}
      {...buttonAttributes}
    >
      {children}
    </button>
  )
}
